import { format, isDate } from 'date-fns'
import { Href } from 'zens-router'

type ParamType = string | number | boolean | Date

const sanitizeParam = (param: ParamType | ParamType[]): string => {
  if (Array.isArray(param)) return param.map(sanitizeParam).join(',')
  if (isDate(param)) return format(param as Date, 'yyyy-MM-dd')
  if (typeof param === 'object') return JSON.stringify(param)
  return `${param}`
}

export function urlForRoute(href: Href) {
  if (typeof href === 'string') return href
  const { pathname, params } = href
  const query: Record<string, ParamType> | undefined = params
    ? Object.keys(params).reduce((acc, key) => ({ ...acc, [key]: sanitizeParam(params[key] as ParamType) }), {})
    : undefined
  return `${pathname}${
    query
      ? `?${Object.keys(query)
          .map((key) => `${key}=${encodeURIComponent(query[key] as string)}`)
          .join('&')}`
      : ''
  }`
}

export function pathnameFromHref(href: Href) {
  if (typeof href === 'string') {
    const pathname = href.replace(/(\?.*)$/, '')
    return pathname
  } else {
    const { pathname } = href
    return pathname
  }
}
